export default function Home({ setCurrentPage }) {
  return (
    <div className="position-relative page-animate pb-5">
      <div className="hero-glow"></div>
      
      <div className="container" style={{ paddingTop: "160px" }}>
        {/* Hero Section */}
        <div className="row justify-content-center text-center mb-5 pb-4 position-relative z-1">
          <div className="col-lg-9 col-md-11">
            <div className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4" style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid var(--border-subtle)' }}>
              <span className="font-mono text-white">v1.0 Deployed</span>
              <span className="text-muted mx-1">|</span>
              <span className="font-mono text-muted">Android Platform</span>
            </div>
            <h1 className="fw-bold mb-4" style={{ fontSize: "clamp(3rem, 5vw, 4.5rem)", lineHeight: "1.1" }}>
              Secure the network. <br className="d-none d-md-block"/> Skip the browser.
            </h1>
            <p className="lead mb-5 px-md-5 text-muted" style={{ fontSize: "1.15rem" }}>
              TapSecureX intercepts malicious DNS payloads, invasive telemetry, and phishing vectors natively on your device—resolving threats in milliseconds before they compromise your data.
            </p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <button className="btn btn-primary d-flex align-items-center justify-content-center gap-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>
                Download APK
              </button>
              <button className="btn btn-secondary" onClick={() => setCurrentPage("about")}>
                Explore Architecture
              </button>
            </div>
          </div>
        </div>

        {/* Bento Grid Architecture */}
        <div className="row g-4 mt-5 position-relative z-1">
          <div className="col-md-8">
            <div className="bento-card">
              <div className="icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <h4 className="mb-3">VpnService Interception</h4>
              <p className="text-muted mb-0 pe-md-5">
                Operating strictly at the OS network layer, TapSecureX spins up a localized VPN loop to safely intercept all outbound DNS requests. No root access required. No traffic leaves your device uninspected.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="bento-card">
              <div className="icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
              </div>
              <h4 className="mb-3">Sub-ms Filtering</h4>
              <p className="text-muted mb-0">
                Deterministic traffic mapping blocks trackers and ads instantly.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="bento-card">
              <div className="icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              </div>
              <h4 className="mb-3">Zero Logging</h4>
              <p className="text-muted mb-0">
                Classification happens locally. Your DNS logs never hit our servers.
              </p>
            </div>
          </div>
          <div className="col-md-8">
            <div className="bento-card" style={{ background: "linear-gradient(145deg, var(--bg-surface) 0%, #050505 100%)" }}>
              <div className="icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
              </div>
              <h4 className="mb-3">SentinelX Sync</h4>
              <p className="text-muted mb-0 pe-md-5">
                Powered by Trinetra SentinelX. The engine asynchronously fetches cryptographic threat signatures, maintaining up-to-the-minute protection without broadcasting your identity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}